const MAX_AUTHORS_DISPLAYED = 4;
const MOBILE_AUTHORS_DISPLAYED = 1;
const DESKTOP_AUTHORS_DISPLAYED = 2;

/**
 * Returns the displayed and expandable authors based on the provided list of authors and device type.
 * @param {Array} authors - The list of authors.
 * @param {boolean} isMobile
 * @param {object} paidAuthor - The paid author object.
 */
export function getDisplayedAndExpandableAuthors(authors, isMobile, paidAuthor) {
  let displayedAuthors = [];
  let expandableAuthors = [];

  if (authors.length <= MAX_AUTHORS_DISPLAYED) {
    displayedAuthors = authors.slice(
      0,
      isMobile ? MOBILE_AUTHORS_DISPLAYED : DESKTOP_AUTHORS_DISPLAYED,
    );
    expandableAuthors = authors.slice(displayedAuthors.length);

    return { displayedAuthors, expandableAuthors };
  }

  if (authors.length > MAX_AUTHORS_DISPLAYED && paidAuthor) {
    const fallbackAuthorData = {
      author: {
        person: {
          name: null,
        },
      },
    };
    const authorWithSponsorAndBrandedFallback = [paidAuthor, fallbackAuthorData];
    displayedAuthors = authorWithSponsorAndBrandedFallback.slice(
      0,
      isMobile ? MOBILE_AUTHORS_DISPLAYED : DESKTOP_AUTHORS_DISPLAYED,
    );
    expandableAuthors = authorWithSponsorAndBrandedFallback.slice(displayedAuthors.length);
  }

  return { displayedAuthors, expandableAuthors };
}
